import { Elastic, Sine, TimelineLite, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as SoundEffect from "../Data/SoundEffect";
import * as VoiceOver from "../Data/VoiceOver";
import { Button } from "../GameObjects/Button";

export class SplashPlayButton extends Button {
    private _loop: TimelineMax | undefined;

    constructor(pCallback: () => void) {
        super(pCallback, "button-play", Constants.SPRITESHEET_UI, VoiceOver.PLAY, SoundEffect.UI_SELECT);
        // Remove the bottom portion of the hitArea to account for baked-in shadow
        this.hitArea = new PIXI.Rectangle(
            -this._image!.width * 0.5,
            -this._image!.height * 0.5,
            this._image!.width,
            this._image!.height * 0.925,
        );
        this.visible = false;
        this.interactive = false;
    }

    public animateIn(): void {
        this.alpha = 0;
        this._visuals.scale.set(0.5);
        this.visible = true;

        const timeline: TimelineLite = new TimelineLite();

        timeline.to(this, 0.35, {
            alpha: 1,
            ease: Sine.easeOut,
        }, 0);
        timeline.to(this._visuals.scale, 1.0, {
            x: 1,
            y: 1,
            ease: Elastic.easeOut,
        }, 0);
        timeline.call(this.animateLoop.bind(this));
        timeline.call(() => this.interactive = true, undefined, this, 0.35);
    }

    protected onPointerOver(pEvent: PIXI.interaction.InteractionEvent): void {
        super.onPointerOver(pEvent);
        if (this._loop !== undefined) {
            this._loop.kill();
            this._loop = undefined;
        }
    }

    protected onPointerOut(pEvent: PIXI.interaction.InteractionEvent): void {
        super.onPointerOut(pEvent);
        this.animateLoop();
    }

    private animateLoop(): void {
        if (this._loop !== undefined) {
            this._loop.kill();
        }
        this._loop = new TimelineMax({
            repeat: -1,
        });

        this._loop.to(this._visuals.scale, 0.15, {
            x: 1.15,
            y: 1.15,
            ease: Sine.easeInOut,
        }, 3);
        this._loop.to(this._visuals.scale, 1.0, {
            x: 1,
            y: 1,
            ease: Elastic.easeOut,
        }, 3.15);
    }
}
